import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import { AuthProvider } from './shared/hooks/Auth';
import { KeyboardProvider } from './shared/hooks/useKeyboard';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <KeyboardProvider>
          <App />
        </KeyboardProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
